import { LocalSettings, WallMode } from "../../settings";
import { AADetectionResults } from "../types";

interface ValidateHardWallStateParams {
  settings: LocalSettings;
  aaDetectionResults: AADetectionResults;
  dismissCount: number;
}
export function validateHardWallState({
  settings,
  aaDetectionResults,
  dismissCount,
}: ValidateHardWallStateParams) {
  const enableHardModeOnAdaptiveWall =
    settings.wall_mode === WallMode.adaptive && !aaDetectionResults.aa;
  const enableHardModeOnDynamicWall =
    settings.wall_mode === WallMode.dynamic &&
    dismissCount >= settings.dynamic_wall_settings.dismiss_count;
  const enableHardModeInitially = settings.wall_mode === WallMode.hard;
  return (
    enableHardModeInitially ||
    enableHardModeOnDynamicWall ||
    enableHardModeOnAdaptiveWall
  );
}
